import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localeEn = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  LABEL_SELECT_CATEGORY: 'Select category: {{name}}'
});
export default localeEn;